module.exports = __webpack_public_path__ + "client/img/s_item_18.a42e771f.png";